import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { SocialProofBar } from './components/SocialProofBar';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PainPointsSection } from './components/PainPointsSection';
import { SystemOverview } from './components/SystemOverview';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTA } from './components/FinalCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      f.fbq('init', '1468583271333005');
      f.fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-brand-bg font-inter selection:bg-brand-accent selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <SocialProofBar data-id="element-2" />
      <TestimonialsSection data-id="element-3" />
      <PainPointsSection data-id="element-4" />
      <SystemOverview data-id="element-5" />
      <BonusSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <GuaranteeSection data-id="element-8" />
      <FinalCTA data-id="element-9" />
      <PurchasePopup data-id="element-10" />
    </div>;
}